import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { IDynamicLanguageVariant } from './dynamic-language.pipe';
import { TranslocoService } from '@jsverse/transloco';

@Injectable()
export class LocalDynamicLanguageService implements IDynamicLanguageVariant {

  private _localLanguage:ReplaySubject<string> = new ReplaySubject<string>(1);

  public lang$:Observable<string> = this._localLanguage.asObservable();
  public setLanguage(lang:string):void {
    this._localLanguage.next(lang);
  }

  constructor(private _translocoService: TranslocoService) {
    const currentLang = this._translocoService.getActiveLang();
    this._localLanguage.next(currentLang);
   }
}
